export const ErrorClassification = {
  TRANSIENT: "TRANSIENT",
  PERMANENT: "PERMANENT",
  INVARIANT_VIOLATION: "INVARIANT_VIOLATION",
} as const;

export type ErrorClassification =
  (typeof ErrorClassification)[keyof typeof ErrorClassification];

export class AppError extends Error {
  readonly classification: ErrorClassification;
  readonly code: string;

  constructor(
    message: string,
    classification: ErrorClassification,
    code: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = "AppError";
    this.classification = classification;
    this.code = code;
  }
}

export function classifyUnknownError(error: unknown): AppError {
  if (error instanceof AppError) {
    return error;
  }

  if (error instanceof Error) {
    return new AppError(
      "An unexpected invariant failed.",
      ErrorClassification.INVARIANT_VIOLATION,
      "UNEXPECTED_ERROR",
      { cause: error },
    );
  }

  return new AppError(
    "An unknown invariant failed.",
    ErrorClassification.INVARIANT_VIOLATION,
    "UNKNOWN_THROWABLE",
  );
}
